import React, { useEffect } from 'react'
import Nav from '../components/Nav'
import Footer from '../components/Footer';
import { register } from 'swiper/element/bundle';
import { Link } from 'react-router-dom';

import '../styles/homescreen.css';

import image1 from '../assets/images/collection/classics/Tezza-8721.jpg';
import image2 from '../assets/images/collection/classics/Tezza-1889.jpg';
import image3 from '../assets/images/collection/classics/Tezza-8721.jpg';
import image4 from '../assets/images/collection/classics/Tezza-5850.jpg';
import image5 from '../assets/images/collection/classics/Tezza-8721.jpg';

const images = [
    image1, image2, image3, image4, image5,
];

const HomeScreen = () => {
    register();
    
    useEffect(() => {
        document.title = `JODORRY | Johannesburg, South Africa`;
    }, []);

    return (
        <>
            <Nav />
            <section className='home-screen'>
                <swiper-container
                    pagination-clickable="true"
                    navigation="true"
                    navigation-next-el=".custom-next-button"
                    navigation-prev-el=".custom-prev-button"
                    pagination-dynamic-bullets="true"
                    autoplay-delay="5000"
                    autoplay-disable-on-interaction="false"
                    center-slides="true"

                    style={
                        {
                            "--swiper-navigation-color": "#CA054D",
                            "--swiper-pagination-color": "#CA054D"
                        }
                    }


                    breakpoints={
                        JSON.stringify({
                            640: {
                                slidesPerView: 1,
                            },
                            768: {
                                slidesPerView: 2,
                            },
                            1024: {
                                slidesPerView: 3,
                            }
                        })
                    }
                >
                    {
                        images.map((image, index) => (
                            <swiper-slide key={index} lazy="true">
                                <img src={image} alt='home-main' className='main-image' loading="lazy" />
                            </swiper-slide>
                        ))
                    }
                </swiper-container>
                <div className="promo-button">
                    <Link to="/promo" className="promo-link">
                        WATCH JODORRY - WOC 2025
                    </Link>
                </div> 
            </section>
            <Footer />
        </>
    )
}

export default HomeScreen